import axios from "axios";

const axisInstance = axios.create({
    baseURL: 'http://localhost:9000',
   
  });

  export default axisInstance